module.exports = __webpack_public_path__ + "static/media/lowresportfolio-36.9e6453d0.jpg";